import { Link } from "react-router-dom";

// Tara Creative Group lockup: TCG monogram + wordmark text beside it.
export const Wordmark = ({ light = false, className = "", testid = "logo-home-link" }) => (
  <Link to="/" data-testid={testid} className={`group inline-flex items-center gap-3.5 ${className}`}>
    <img
      src="/logos/tara-monogram.jpg"
      alt="Tara Creative Group"
      className="h-14 md:h-[68px] w-auto rounded-sm select-none"
      draggable="false"
    />
    <span className="flex flex-col leading-none">
      <span className={`font-serif text-2xl md:text-[32px] tracking-tight ${light ? "text-cream" : "text-bottle-green"}`}>
        Tara
      </span>
      <span className={`font-mono text-[9px] md:text-[11px] tracking-[0.34em] uppercase mt-1 ${light ? "text-cream/70" : "text-dark-text/55"}`}>
        Creative Group
      </span>
    </span>
  </Link>
);
